import * as React from "react";
import { forwardRef } from "react";
const GaugeArrowRightIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.085 8.494a8.67 8.67 0 0 1 12.027-.001.777.777 0 0 1 .23.23 8.67 8.67 0 0 1-.112 12.143.75.75 0 0 1-1.06 0l-.039-.042a.77.77 0 0 1-.041-.038l-1.197-1.197a.75.75 0 0 1 1.061-1.061l.719.719a7.136 7.136 0 0 0 1.558-3.761h-1.062a.75.75 0 1 1 0-1.5h1.062a7.131 7.131 0 0 0-1.556-3.762l-.629.63a.75.75 0 0 1-1.061-1.061l.629-.63a7.14 7.14 0 0 0-3.796-1.562v.834a.75.75 0 1 1-1.5 0v-.826A7.132 7.132 0 0 0 6.59 9.162l.63.63 2.792 2.793a.717.717 0 0 1 .052.058 2.29 2.29 0 0 1 1.055-.257 2.3 2.3 0 0 1 2.3 2.3 2.3 2.3 0 0 1-2.3 2.3 2.3 2.3 0 0 1-2.3-2.3 2.29 2.29 0 0 1 .217-.969.76.76 0 0 1-.084-.071l-3.05-3.05-.372-.373a7.144 7.144 0 0 0-1.557 3.763h.996a.75.75 0 1 1 0 1.5h-.996a7.14 7.14 0 0 0 1.557 3.762l.721-.72a.75.75 0 1 1 1.062 1.061l-1.198 1.197a.77.77 0 0 1-.06.053c-.008.008-.013.019-.021.027a.75.75 0 0 1-1.004.052l-.057-.052-.308-.322A8.67 8.67 0 0 1 4.859 8.72a.738.738 0 0 1 .226-.226zm6.031 5.392a.8.8 0 0 0-.8.8.8.8 0 0 0 .8.8.8.8 0 0 0 .8-.8.8.8 0 0 0-.8-.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.55 4.365a.75.75 0 0 1 .75.75v1.122l1.542-1.423a.75.75 0 0 1 1.018 1.102l-1.461 1.35h1.052a.75.75 0 1 1 0 1.5h-2.9a.75.75 0 0 1-.75-.75v-2.9a.75.75 0 0 1 .75-.75z"
}));
const ForwardRef = forwardRef(GaugeArrowRightIcon);
export default ForwardRef;